import { Injectable } from '@angular/core';
import {  Observable, of } from 'rxjs';

import { BehaviorSubject } from 'rxjs';
import { Params } from '@angular/router';
import { delay, first, map } from 'rxjs/operators';
import { User } from './user';
import { MasterDetailResource } from '../services/master-detail-resource';


@Injectable()
export class UserService implements MasterDetailResource<User, Params, String> {


  public items: Observable<any[]>;
  public pageSize = 500;
  public pageCount = 0;
  public itemCount = 0;
  public currentPage = 0;
  public pages = [];
  sampleData = [
    new User('1', 'Bob', 'Administrator', 'Security', 'Bob@company.com', this.generateEntryDate(50)),
    new User('2', 'Sarah', 'User', 'Sales', 'Sarah@company.com', this.generateEntryDate(30)),
    new User('3', 'Michael', 'User', 'Recruiting', 'Michael@company.com', this.generateEntryDate(5)),
    new User('4', 'Megan', 'User', 'Cloud Development', 'Megan@company.com', new Date()),
    new User('5', 'Alice', 'Administrator', 'Infrastructure', 'Alice@company.com', this.generateEntryDate(51)),
    new User('6', 'Charlie', 'User', 'Security', 'Charlie@company.com', this.generateEntryDate(40)),
    new User('7', 'Deborah', 'User', 'Sales', 'Deborah@company.com', this.generateEntryDate(43)),
    new User('8', 'Eric', 'User', 'Infrastructure', 'Eric@company.com', this.generateEntryDate(2)),
    new User('9', 'Frank', 'User', 'Sales', 'Frank@company.com', this.generateEntryDate(5)),
    new User('10', 'George', 'User', 'Recruiting', 'George@company.com', this.generateEntryDate(45))
  ];
  private readonly _items: BehaviorSubject<any[]>;
  private _lastQuery: Params | undefined;

  private static compareUsers(a: User, b: User, attribute: string): number {
    return a.compare(b, attribute);
  }

  constructor() {
    this._items = new BehaviorSubject<any>([]);
    this.items = this._items.asObservable().pipe(
      delay(500) // fake some latency
    );
  }

  queryDepartments(): Observable<Set<string>> {
    return this.items.pipe(map(items => new Set(items.map(user => user.department))));
  }

  querySingle(id: string): Observable<User> {
    return of(this.sampleData.find(value => value.id === id)).pipe(
      first(),
      delay(500) // fake some latency
    );
  }

  queryAll(params?: Params): Observable<User[]> {
    this._lastQuery = params;

    let page = 0;
    let sortAttribute = 'id';

    if (params) {
      if (params.hasOwnProperty('page')) {
        page = +params['page'];
      }

      if (params.hasOwnProperty('sort')) {
        sortAttribute = params['sort'];
      }
    }

    const start = page * this.pageSize;
    const end = start + this.pageSize;

    const selectedItems = this.sampleData.sort((a, b) => UserService.compareUsers(a, b, sortAttribute)).slice(start, end);

    this.itemCount = selectedItems.length;

    this.computeAvailablePages(page);
    this.currentPage = page;

    this._items.next(selectedItems);
    return this.items;
  }

  upsert(user: User): User {
    const index = this.sampleData.findIndex(value => value.id === user.id);
    if (index >= 0) {
      this.sampleData[index] = user;
    } else {
      this.sampleData.push(user);
    }
    this.queryAll(this._lastQuery);
    return user;
  }

  remove(users: User[]) {
    this.sampleData = this.sampleData.filter(user => users.indexOf(user) < 0);
    this.queryAll(this._lastQuery);
  }


  private computeAvailablePages(page: number) {
    this.pageCount = Math.ceil(this.sampleData.length / this.pageSize);
    this.pages.length = 0;
    for (let i = 0; i < this.pageCount; i++) {
      this.pages.push({ index: i, active: (i === page) });
    }
  }

  private generateEntryDate(daysAgo: number) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date;
  }
}
